<template>
  <div>
    count is {{ counterVaule }}
  </div>
</template>

<script>
  import { getCount } from '../vuex/getters.js';
  export default {
    vuex: {
      getters: {
        counterVaule: getCount,
      },
    },
  };
</script>

<style scoped>
div {
  color: rgb(72, 214, 154);
}
</style>



/** WEBPACK FOOTER **
 ** Display.vue?fc84cf2a
 **/